//import axios from 'axios';
import api from '../../api';

import {
  CART_ADD_ITEM,
  CART_REMOVE_ITEM,
  CART_SAVE_PAYMENT_METHOD,
  CART_SAVE_SHIPPING_ADDRESS,
} from '../constant/cartConstans';

export const addToCart = (id: string, qty: number) => async (dispatch: any, getState: any) => {
  //const { data } = await axios.get(`/products/${id}`);

  const { data } = await api.get(`/products/${id}`);
  dispatch({
    type: CART_ADD_ITEM,
    payload: {
      product: data._id,
      name: data.name,
      imagen: data.imagen,
      price: data.price,
      countInStock: data.countInStock,
      qty,
    },
  });
  localStorage.setItem('cartItems', JSON.stringify(getState().cart.cartItems));
};

export const saveShippingAddress = (data: any) => (dispatch: any) => {

  dispatch({ type: CART_SAVE_SHIPPING_ADDRESS, payload: data });
  localStorage.setItem('shippingAddress', JSON.stringify(data));
};

export const removeFromCart = (productId: string) => (dispatch: any, getState: any) => {
  dispatch({
    type: CART_REMOVE_ITEM,
    payload: productId,
  });

  localStorage.setItem('cartItems', JSON.stringify(getState().cart.cartItems));
};

export const savePaymentMethod = (data: string) => (dispatch: any) => {
  dispatch({ type: CART_SAVE_PAYMENT_METHOD, payload: data });

};
